import { isNotNil } from '@tryiris-ai/js-types';

/** Encoder probes publish -1 on failure; formatted percentages retain that sentinel. */
export const isBridgeDetailAvailable = <T extends string | number>(
  value: T | null | undefined
): value is T => isNotNil(value) && Number(value) >= 0;
